import React from 'react';

import type { Props } from '../types/PageSegmentLoadEndProps.ts';

import { UFOSegmentLoadEnd } from './UFOSegmentLoadEnd.tsx';

/**
 * Component that calls addUFOCustomData directly for page segment load end.
 */
export const PageSegmentLoadEnd = (props: Props) => {
	return <UFOSegmentLoadEnd {...props} />;
};
